import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { communicationApi, type ProviderConfig } from '../../api/communication';

export function ProviderManagerPage() {
  const [providers, setProviders] = useState<ProviderConfig[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void communicationApi.listProviders().then((r) => setProviders(r.providers)).catch((e) => setError(String(e)));
  }, []);

  const byChannel = providers.reduce<Record<string, ProviderConfig[]>>((acc, p) => {
    (acc[p.channel] ??= []).push(p);
    return acc;
  }, {});

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/communication" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Communication Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Provider Manager</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Configured delivery providers by channel. Adapters are interchangeable.
      </p>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-6">
        {Object.entries(byChannel).map(([channel, list]) => (
          <div key={channel}>
            <h2 className="text-lg font-medium capitalize">{channel.replace('_', ' ')}</h2>
            <ul className="mt-2 space-y-2">
              {list.map((p) => (
                <li key={p.id} className="flex items-center justify-between rounded-lg border p-3 dark:border-slate-700">
                  <span>{p.name}</span>
                  <span className={`rounded px-2 py-0.5 text-xs ${p.active ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-slate-100 text-slate-600 dark:bg-slate-800'}`}>
                    {p.active ? 'Active' : 'Inactive'} · P{p.priority}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
